export const topics = [
  {
    id: "dingliu",
    name: "顶流风波",
    slug: "dingliu",
    slogan: "热度越高，水花越大",
    description:
      "聚焦当红顶流身上的话题漩涡：资源变动、数据争议、粉丝与路人之间的拉扯，都在这里被拆开来讲清楚。",
    count: 38,
    image:
      "https://readdy.ai/api/search-image?query=Concert%20stage%20lights%20and%20golden%20confetti%20seen%20from%20behind%20the%20stage%2C%20warm%20dramatic%20backlight%2C%20abstract%20cinematic%20editorial%20photography%2C%20coral%20and%20amber%20tones%2C%20no%20people%2C%20high%20detail%20texture&width=800&height=600&seq=gt-topic-dingliu&orientation=landscape",
  },
  {
    id: "juzu",
    name: "剧组秘闻",
    slug: "juzu",
    slogan: "镜头之外，故事更多",
    description:
      "从选角到杀青，剧组里那些不会写进通稿的细节：临时换人、番位博弈、拍摄日常的花絮与摩擦。",
    count: 26,
    image:
      "https://readdy.ai/api/search-image?query=Empty%20film%20set%20with%20lighting%20rigs%20and%20a%20clapperboard%20resting%20on%20a%20director%20chair%2C%20warm%20dramatic%20lighting%2C%20cinematic%20editorial%20photography%2C%20coral%20and%20amber%20tones%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=gt-topic-juzu&orientation=landscape",
  },
  {
    id: "zongyi",
    name: "综艺内幕",
    slug: "zongyi",
    slogan: "台本之外的真实",
    description:
      "剪辑如何讲故事、嘉宾如何被安排、名场面是巧合还是设计，综艺背后的逻辑一次说明白。",
    count: 21,
    image:
      "https://readdy.ai/api/search-image?query=Television%20studio%20backdrop%20with%20soft%20bokeh%20stage%20lights%20and%20colorful%20haze%2C%20abstract%20cinematic%20editorial%20photography%2C%20cream%20and%20amber%20tones%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=gt-topic-zongyi&orientation=landscape",
  },
  {
    id: "daiyan",
    name: "代言与资源",
    slug: "daiyan",
    slogan: "商务背后的一盘棋",
    description:
      "谁在抢同一个代言、品牌为何突然换人、数据与口碑如何影响商务，资源流动背后的门道。",
    count: 17,
    image:
      "https://readdy.ai/api/search-image?query=Luxury%20perfume%20bottle%20and%20cosmetic%20products%20arranged%20on%20a%20marble%20vanity%20with%20warm%20spotlight%2C%20elegant%20editorial%20still%20life%2C%20coral%20and%20cream%20tones%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=gt-topic-daiyan&orientation=landscape",
  },
  {
    id: "sixia",
    name: "私下交集",
    slug: "sixia",
    slogan: "关系网络，慢慢显影",
    description:
      "同框、聚餐、探班、互相点赞，这些被镜头捕捉到的细节，拼出圈内真实的人际地图。",
    count: 14,
    image:
      "https://readdy.ai/api/search-image?query=Two%20coffee%20cups%20on%20a%20small%20cafe%20table%20beside%20a%20rain%20streaked%20window%2C%20warm%20intimate%20moody%20lighting%2C%20cinematic%20editorial%20photography%2C%20amber%20and%20cream%20tones%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=gt-topic-sixia&orientation=landscape",
  },
  {
    id: "hangye",
    name: "行业观察",
    slug: "hangye",
    slogan: "把瓜吃出方法论",
    description:
      "跳出单个事件，从行业视角看热搜机制、营销套路与舆论走向，帮你把瓜吃得更有层次。",
    count: 23,
    image:
      "https://readdy.ai/api/search-image?query=Stack%20of%20entertainment%20magazines%20and%20newspapers%20on%20a%20wooden%20desk%20under%20warm%20lamp%20light%2C%20moody%20editorial%20still%20life%2C%20coral%20and%20amber%20tones%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=gt-topic-hangye&orientation=landscape",
  },
];